/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  selectDialog,
  selectInvitationId,
  selectStatus,
  toggleDialog,
  updateInvitationId,
} from './invitation.resend.slice';
import { resendInvitation } from './invitation.resend.thunk';

export default function UseResendInvitation(orgId, resetInvitations) {
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const resendDialog = useSelector(selectDialog);
  const invitationId = useSelector(selectInvitationId);

  const onToggleResendDialog = open => dispatch(toggleDialog(open));
  const onUpdateInvitationId = newInvitationId => dispatch(updateInvitationId(newInvitationId));

  useEffect(() => {
    if (status === ThunkStatus.SUCCEEDED) {
      onToggleResendDialog(false);
      resetInvitations();
    }

    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const onResendInvitationConfirmation = (invitationToResend) => {
    dispatch(resendInvitation({ invitationId: invitationToResend, organizationId: orgId }));
  };

  return {
    isLoading,
    resendDialog,
    invitationId,
    updateInvitationId,
    onUpdateInvitationId,
    onResendInvitationConfirmation,
    onToggleResendDialog,
  };
}
